import BaseRequestService from 'pages/download-zone/services/BaseRequestService';

class LoadingPageContent extends BaseRequestService {
  getLoadingPageData = (id) => {
    return this.getRequest('/api/downloads/center/tour/' + id);
  };
}

export default new LoadingPageContent();
